import {
  VpFormControl,
  VpFormLabel,
  VpInput,
  VpTextarea,
} from '@vtmn-play/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TextField } from '../CreateUserNeedForm';
import './user-need-details.scss';

export type UserNeedDetailsProps = {
  setUnLabel: (value: TextField) => void;
  setUnDescr: (value: TextField) => void;
};

export const UserNeedDetails = ({
  setUnLabel,
  setUnDescr,
}: UserNeedDetailsProps) => {
  const { t } = useTranslation();
  const [userNeedLabel, setUserNeedLabel] = useState('');
  const [userNeedDescr, setUserNeedDescr] = useState('');
  const [labelError, setLabelError] = useState<string | null>(null);
  const [descrError, setDescrError] = useState<string | null>(null);

  const checkInvalidDescr = (description: string) => {
    if (description.length > 150) {
      setDescrError(t('architecture.drawer.user-need.desc-less-than'));
      setUnDescr({ text: userNeedDescr, hasError: true });
    } else {
      setDescrError(null);
      setUnDescr({ text: userNeedDescr, hasError: false });
    }
  };

  const checkInvalidLabel = (label: string) => {
    const noMatch = !/^[a-zA-Z0-9]+(?:[\s-]+[a-zA-Z0-9]+)*$/.exec(label);
    if (!label) {
      setLabelError(t('architecture.drawer.user-need.mandatory-label'));
    } else if (noMatch && label.length > 40) {
      setLabelError(
        t('architecture.drawer.user-need.label-no-match-and-less-than'),
      );
    } else if (label.length > 40) {
      setLabelError(t('architecture.drawer.user-need.label-less-than'));
    } else if (noMatch) {
      setLabelError(t('architecture.drawer.user-need.label-no-match'));
    } else {
      setLabelError(null);
    }
    setUnLabel({
      text: userNeedLabel,
      hasError: !label || noMatch || label.length > 40,
    });
  };

  return (
    <VpFormControl
      className="user-need-details"
      data-testid="user-need_details"
    >
      <VpFormLabel className="user-need-form-labels">
        {t('architecture.drawer.user-need.form-label')}
      </VpFormLabel>
      <VpInput
        id="user-need-label"
        name="user-need-label"
        data-testid="user-need_label_input"
        value={userNeedLabel}
        onBlur={() => checkInvalidLabel(userNeedLabel.trim())}
        onChange={(e) => setUserNeedLabel(e.target.value)}
        className="user-need-label"
      />
      {labelError && (
        <div
          className="un-form-label-error"
          data-testid="user-need_form_label-error"
        >
          {labelError}
        </div>
      )}
      <VpFormLabel className="user-need-form-labels">
        {t('architecture.drawer.user-need.form-description')}
      </VpFormLabel>
      <VpTextarea
        id="user-need-descr"
        name="user-need-descr"
        data-testid="user-need_description_input"
        value={userNeedDescr}
        onBlur={() => checkInvalidDescr(userNeedDescr.trim())}
        onChange={(e) => setUserNeedDescr(e.target.value)}
        className="user-need-descr"
      />
      {descrError && (
        <div
          className="un-form-label-error"
          data-testid="user-need_form_description-error"
        >
          {descrError}
        </div>
      )}
    </VpFormControl>
  );
};
